import { Suspense } from 'react';
import { ArtistMinifiedType } from '@api';
import { SearchTableInput, Tabs, useManageTableContext } from '@common';
import { AddArtist, ArtistsOverviewTable } from '@features';
import { Box, Group, Skeleton } from '@mantine/core';
import { PageLayout } from '@pages';
import { useTranslation } from 'react-i18next';

type ArtistsPagePropsType = {
  artists: ArtistMinifiedType[];
  isPending: boolean;
};

export const ArtistsPage: React.FC<ArtistsPagePropsType> = ({
  artists,
  isPending,
}) => {
  const { t } = useTranslation('artists');

  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  const tabs = [
    {
      label: t('TABS.OVERVIEW'),
      value: 'overview',
    },
  ];

  return (
    <PageLayout title={t('TITLE')}>
      <Tabs value="overview">
        <Tabs.TabsList>
          {tabs.map((tab) => (
            <Tabs.Tab key={tab.value} value={tab.value} to={`/artists`}>
              {tab.label}
            </Tabs.Tab>
          ))}
          <Tabs.TabsListActions>
            <Suspense fallback={<Skeleton height={30} width={45} />}>
              <AddArtist />
            </Suspense>
          </Tabs.TabsListActions>
        </Tabs.TabsList>
      </Tabs>
      <Box py="md">
        <Group justify="end" mb="xs">
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
            autoFocus
          />
        </Group>
        <ArtistsOverviewTable artists={artists} isPending={isPending} />
      </Box>
    </PageLayout>
  );
};
